<!-- File: NavItems.vue -->
<template>
  <ul class="navigation">
    <li><router-link to="/">Beranda</router-link></li>
    
    <!-- <li><router-link to="/berita">Berita</router-link></li> -->

    <li class="menu-item-has-children">
      <a href="javascript:void(0);">Informasi</a>
      <ul class="sub-menu">
        <li><router-link to="/BeritaOPD">Berita</router-link></li>
        <li>
          <a href="https://konaweselatankab.go.id/agenda_pengumuman/pengumuman/list" target="_blank" rel="noopener noreferrer">
            Pengumuman
          </a>
        </li>
      </ul>
    </li>

    <li class="menu-item-has-children">
      <a href="javascript:void(0);">Profil</a>
      <ul class="sub-menu">
        <li><router-link to="/ProfilDewan">Profil Dewan</router-link></li>
        <li><router-link to="/ProfilPegawai">Pejabat Struktural</router-link></li>
        <li><router-link to="/StrukturOrganisasi">Struktur Organisasi</router-link></li>
        <li><router-link to="/AlatDewan">Alat Kelengkapan Dewan</router-link></li>
      </ul>
    </li>
    <li><router-link to="/FraksiFraksi">Fraksi-Fraksi</router-link></li>
    <li><router-link to="/KomisiKomisi">Komisi DPRD</router-link></li>

    <li class="menu-item-has-children">
      <a href="javascript:void(0);">Data & Dokumen</a>
      <ul class="sub-menu">
        <li><router-link to="/DataDokumen">Dokumen</router-link></li>
        <li><router-link to="/DataLainnya">Data Lainnya</router-link></li>
      </ul>
    </li>
    <li><router-link to="/DataJDIH">JDIH</router-link></li>
    <li class="menu-item-has-children">
      <a href="javascript:void(0);">Galeri</a>
      <ul class="sub-menu">
        <li><router-link to="/FotoOPD">Foto</router-link></li>
        <li><router-link to="/VideoOPD">Video</router-link></li>
      </ul>
    </li>


  </ul>
</template>
